/**
 * Create modal context for custom hook
 */
import { createContext } from 'react'

const ModalContext = createContext({
  isOpen: false,
  title: '',
  data: {},
  loadingSections: [],
  refinedFilters: {},
  open: () => {},
  onRequestClose: () => {},
  onClear: () => {},
  onChange: () => {},
  onApply: () => {},
})

export default ModalContext
